export default function mail(axios: any) {
  const getEmail = async () => {
    try {
      const response = await axios.get('email');
      if (response.status === 200) return response.data.data;
    } catch (err) {
      console.log('[api/mail.ts] getEmail');
    }
    return {};
  };

  const updateEmailSubject = async (subject: string) => {
    try {
      const response = await axios.post('email/subject', {
        subject,
      });
      if (response.status === 200) return response.data;
    } catch (err) {
      console.log('[api/mail.ts] updateEmailSubject');
    }
    return { status: 1 };
  };

  const updateEmail = async (payload: any) => {
    try {
      const response = await axios.post('email', payload);
      if (response.status === 200) return response.data;
    } catch (err) {
      console.log('[api/mail.ts] updateEmail');
    }
    return { status: 1 };
  };

  const deleteLanguage = async (languageKey: string) => {
    try {
      const response = await axios.delete(`email/delete/${languageKey}`);
      if (response.status === 200) return response.data;
    } catch (err) {
      console.log('[api/mail.ts] deleteLanguage');
    }
    return { status: 1 };
  };

  async function deleteEmailImage() {
    try {
      const response = await axios.delete('email/image');
      if (response.status === 200) return response.data;
    } catch (err) {
      console.log('[api/mail.ts] deleteEmailImage');
    }
    return { status: 1 };
  }

  return {
    getEmail,
    updateEmailSubject,
    updateEmail,
    deleteLanguage,
    deleteEmailImage,
  };
}
